<div class="group/shell w-screen h-screen flex flex-col" [class.nav-pinned]="navPinned">

    <!-- no pl: the logo box below starts at x=0 so its right edge is exactly the rail edge -->
    <nav class="app-topbar flex items-center justify-between text-white py-3 pr-3">
        <span class="flex items-center">
            <!-- tracks the rail width, so the divider that follows always sits on the rail's outer edge;
                 wordmark is too wide for the 3.5rem collapsed rail, so it slides out like the nav labels -->
            <span
                class="flex w-14 shrink-0 items-center justify-center overflow-hidden group-has-[#sidenav:hover]/shell:w-56
                    group-[.nav-pinned]/shell:w-56
                    transition-[width] duration-300 ease-in-out delay-100 group-has-[#sidenav:hover]/shell:delay-0">
                <img
                    src="assets/logo-valamar-white.svg"
                    alt="Valamar"
                    class="h-8 max-w-none shrink-0 translate-x-56 group-has-[#sidenav:hover]/shell:translate-x-0
                        group-[.nav-pinned]/shell:translate-x-0
                        transition-transform duration-300 ease-in-out delay-100 group-has-[#sidenav:hover]/shell:delay-0" />
            </span>
            <span class="flex flex-col justify-center border-l border-white/40 pl-4 leading-tight">
                @if (activeCrumb.section) {
                    <span class="text-xs font-semibold uppercase tracking-wide text-white/70">
                        {{ activeCrumb.section }}
                    </span>
                }
                <span class="text-lg font-semibold">{{ activeCrumb.page }}</span>
            </span>
        </span>
        <span class="flex items-center gap-2.5">
            <button
                type="button"
                (click)="toggleDarkMode()"
                [attr.aria-pressed]="darkMode"
                [attr.aria-label]="darkMode ? 'Prebaci na svijetli način' : 'Prebaci na tamni način'"
                class="app-topbar-icon app-theme-toggle"
                [class.is-moon]="!darkMode">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <mask id="valbenThemeMask">
                        <rect x="0" y="0" width="24" height="24" fill="#fff" />
                        <circle class="app-theme-bite" cx="26" cy="5" r="7.5" fill="#000" />
                    </mask>
                    <circle class="app-theme-orb" cx="12" cy="12" r="6" mask="url(#valbenThemeMask)" />
                    <g class="app-theme-rays" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">
                        <line x1="12" y1="1.6" x2="12" y2="3.6" />
                        <line x1="12" y1="20.4" x2="12" y2="22.4" />
                        <line x1="1.6" y1="12" x2="3.6" y2="12" />
                        <line x1="20.4" y1="12" x2="22.4" y2="12" />
                        <line x1="4.8" y1="4.8" x2="6.2" y2="6.2" />
                        <line x1="17.8" y1="17.8" x2="19.2" y2="19.2" />
                        <line x1="4.8" y1="19.2" x2="6.2" y2="17.8" />
                        <line x1="17.8" y1="6.2" x2="19.2" y2="4.8" />
                    </g>
                </svg>
            </button>
            <span class="app-topbar-divider" aria-hidden="true"></span>

            <span class="app-topbar-user">{{ user }}</span>

            <button type="button" (click)="logout()" class="app-topbar-logout">
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <g class="app-topbar-logout-arrow">
                        <path d="M16 17l5-5-5-5" />
                        <path d="M21 12H9" />
                    </g>
                </svg>
                <span>Odjava</span>
            </button>
        </span>
    </nav>

    <div class="grow w-screen flex flex-nowrap overflow-hidden">
        <nav
            id="sidenav"
            class="app-sidenav group flex h-full w-14 shrink-0 hover:w-56 group-[.nav-pinned]/shell:w-56 flex-col overflow-y-auto overflow-x-hidden py-3 text-sm
                transition-[width] duration-300 ease-in-out delay-100 hover:delay-0">
            <button
                type="button"
                (click)="togglePin(pinTooltip)"
                [attr.aria-pressed]="navPinned"
                [attr.aria-label]="navPinned ? 'Otključaj izbornik' : 'Zaključaj izbornik'"
                [matTooltip]="navPinned ? 'Otključaj izbornik' : 'Zaključaj izbornik'"
                #pinTooltip="matTooltip"
                matTooltipPosition="right"
                [matTooltipHideDelay]="0"
                [matTooltipShowDelay]="0"
                [ngClass]="navPinned ? 'is-pinned' : ''"
                class="nav-pin pin-toggle mx-2 mb-1 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent">
                <svg
                    class="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    [class.is-locked]="navPinned">
                    <mask id="pinLockKeyhole" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect x="0" y="0" width="24" height="24" fill="white" />
                        <circle class="keyhole" cx="12" cy="16" r="0" fill="black" />
                    </mask>
                    <g mask="url(#pinLockKeyhole)">
                        <rect class="bar-top" x="3" y="5" width="18" height="2" rx="1" />
                        <rect class="bar-mid" x="3" y="11" width="18" height="2" rx="1" ry="1" />
                        <rect class="bar-bot" x="3" y="17" width="18" height="2" rx="1" />
                        <path
                            class="shackle"
                            d="M8 11V9a4 4 0 0 1 8 0v2"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round" />
                    </g>
                </svg>
            </button>
            <div
                class="flex w-56 shrink-0 flex-col gap-2 px-2 pb-3 -translate-x-56 group-hover:translate-x-0 group-[.nav-pinned]/shell:translate-x-0
                    pointer-events-none group-hover:pointer-events-auto group-[.nav-pinned]/shell:pointer-events-auto
                    transition-transform duration-300 ease-in-out delay-100 group-hover:delay-0">
            @for (section of items; track section.label) {
                @if (section.items?.length) {
                    <div class="nav-group">
                    <button
                        type="button"
                        (click)="toggleNavGroup(section.label!)"
                        class="nav-section flex w-full cursor-pointer items-center justify-between gap-2 border-0 bg-transparent px-4 pb-1 pt-3 text-left">
                        <span class="min-w-0 flex-1 truncate text-[0.6875rem] font-semibold uppercase tracking-[0.14em]">
                            {{ section.label }}
                        </span>
                        <mat-icon
                            class="nav-section-caret flex !h-4 !w-4 shrink-0 items-center justify-center !text-base !leading-4"
                            [class.is-collapsed]="!navGroupOpen[section.label!]">
                            {{ navGroupOpen[section.label!] ? "expand_less" : "expand_more" }}
                        </mat-icon>
                    </button>
                    <!-- 0fr->1fr animates to auto height without measuring; child needs overflow-hidden to shrink -->
                    <div
                        class="grid transition-[grid-template-rows] duration-200 ease-in-out"
                        [ngClass]="navGroupOpen[section.label!] ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
                        [attr.inert]="navGroupOpen[section.label!] ? null : ''">
                        <div class="overflow-hidden">
                            <div class="flex flex-col gap-1 px-2 pb-2">
                                @for (sub of section.items; track sub.routerLink) {
                                    <a
                                        [routerLink]="sub.routerLink"
                                        routerLinkActive="is-active"
                                        [routerLinkActiveOptions]="{ exact: false }"
                                        class="nav-link relative flex min-w-0 items-center gap-2 rounded-lg py-2 pl-3 pr-2 text-sm no-underline">
                                        <span class="min-w-0 flex-1 leading-snug">{{ sub.label }}</span>
                                        @if (sub.badge) {
                                            <span
                                                class="shrink-0"
                                                [ngClass]="sub.badgeStyleClass">{{ sub.badge }}</span>
                                        }
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                    </div>
                }
                @if (section.routerLink && !section.items?.length) {
                    <div class="nav-group px-2 py-2">
                        <a
                            [routerLink]="section.routerLink"
                            routerLinkActive="is-active"
                            [routerLinkActiveOptions]="{ exact: false }"
                            class="nav-link relative block rounded-lg py-2 pl-3 pr-2 text-sm no-underline">
                            {{ section.label }}
                        </a>
                    </div>
                }
            }
            </div>
        </nav>
        <div class="flex grow overflow-auto">
            <router-outlet></router-outlet>
        </div>
    </div>

</div>
